import { LocationUtilities } from './utils';
const init = (dataCenterId, product, type) => {
  let countryCodes = {
    EU: {
      countryName: 'Europe',
      countryList: ['AT', 'AL', 'AD', 'BE', 'BY', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'VT', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'ME', 'MC', 'MD', 'MK', 'NL', 'VT', 'PL', 'PT', 'RO', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'VA', 'UA', 'GB']
    },
    AU: {
      countryName: 'Australia',
      countryList: ['AU', 'NZ']
    },
    IN: {
      countryName: 'India',
      countryList: ['IN']
    },
    US: {
      countryName: 'United States',
      countryList: ['US']
    },
    ME: {
      countryName: 'Middle East & Africa',
      countryList: ['BH', 'CY', 'EG', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'PS', 'QA', 'SA', 'SY', 'AE', 'YE', 'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM', 'CF', 'TD', 'KM', 'CG', 'CD', 'DJ', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'SH', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'ZM', 'ZW']
    }
  };
  if (product === 'fservice') {
    countryCodes = {
      EU: {
        countryName: 'Europe',
        countryList: ['AL', 'AD', 'AT', 'BY', 'BE', 'BA', 'IO', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'DE', 'GI', 'GR', 'GG', 'HU', 'IS', 'IE', 'IM', 'IT', 'JE', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SJ', 'SE', 'CH', 'TR', 'UA', 'GB', 'VA', 'AX', 'CZ', 'XK', 'MK', 'CS']
      },
      AU: {
        countryName: 'Australia',
        countryList: ['AQ', 'BV', 'TF', 'HM', 'AS', 'AU', 'CX', 'CK', 'FJ', 'PF', 'GU', 'KI', 'MH', 'FM', 'NR', 'NC', 'NZ', 'NU', 'NF', 'MP', 'PW', 'PG', 'WS', 'SB', 'TL', 'TK', 'TO', 'TV', 'VU', 'WF', 'GS', 'PN']
      },
      IN: {
        countryName: 'India',
        countryList: ['IN']
      },
      US: {
        countryName: 'United States',
        countryList: ['YT', 'EH', 'AF', 'AM', 'AZ', 'BD', 'BT', 'BN', 'KH', 'CN', 'GE', 'HK', 'ID', 'JP', 'KZ', 'KG', 'MO', 'MY', 'MV', 'MN', 'MM', 'NP', 'PK', 'PH', 'SG', 'LK', 'TW', 'TJ', 'TH', 'TM', 'UZ', 'VN', 'AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'BM', 'CA', 'KY', 'CR', 'CU', 'DM', 'DO', 'SV', 'GL', 'GD', 'GP', 'GT', 'HT', 'HN', 'JM', 'MQ', 'MX', 'MS', 'NI', 'PA', 'PR', 'LC', 'MF', 'PM', 'SX', 'TT', 'TC', 'US', 'AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF', 'GY', 'PY', 'PE', 'SR', 'UY', 'VE', 'CI', 'RE', 'CC', 'LA', 'KP', 'KR', 'BQ', 'VG', 'CW', 'AN', 'BL', 'KN', 'VC', 'VI', 'UM']
      },
      ME: {
        countryName: 'Middle East & Africa',
        countryList: ['BH', 'CY', 'EG', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'PS', 'QA', 'SA', 'SY', 'AE', 'YE', 'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM', 'CF', 'TD', 'KM', 'CG', 'CD', 'DJ', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'SH', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'ZM', 'ZW']
      }
    };
  }

  let nearestDC = 'US';
  const $dataCenterElement = $(dataCenterId);
  if (!$dataCenterElement.length) { return; }
  const $form = $dataCenterElement.closest('form');
  const $dataCenterSelect = $dataCenterElement.find('select');
  const $selectedDataCenter = $dataCenterElement.find('[data-nearest-center');

  LocationUtilities.onLocationReady(function (geoLocation, simpleGeoLocation) {
    const countryCode = simpleGeoLocation.countryCode;
    if (product === 'fteam') {
      delete countryCodes['IN'];
      delete countryCodes['AU'];
    }
    $.each(countryCodes, function (key, value) {
      $dataCenterSelect.append($('<option>', { value: key }).text(value.countryName));
      if (value.countryList.includes(countryCode)) {
        nearestDC = key;
      }
    });

    $dataCenterElement.find('.data-center-text').css('visibility', 'visible');
    $selectedDataCenter.text(countryCodes[nearestDC].countryName);
    $dataCenterSelect.val(nearestDC).addClass('field-fix').trigger('change');
    $dataCenterElement.find('[data-center-link]').on('click', function () {
      $dataCenterElement.find('.field-dropdown').show().attr({
        'aria-hidden': 'false',
        tabindex: 0
      });
      $dataCenterElement.find(type === 'cro_signup_experiment_form' ? '[data-center-link]' : '.data-center-text').hide().attr({
        'aria-hidden': 'true',
        tabindex: -1
      });
    });
    updateSignupUrl($form, nearestDC);
  });

  $dataCenterSelect.on('change', function () {
    $selectedDataCenter.text(countryCodes[this.value].countryName);
    updateSignupUrl($form, this.value);
  });
};

const updateSignupUrl = ($form, region) => {
  const signupRegionsApi = $form.data('signup-regions');
  if (signupRegionsApi) {
    $form.data('signup-url', signupRegionsApi[region]);
  }
};

export default { init };
